import "./App.css";
import AppRoutes from "./routes/Index";

function App() {
  return <AppRoutes/>
}

export default App;